export default function guestChatbot({ next, router }) {
  if (window.Laravel.user !== null) {
    return router.push({ name: 'chatbotByMachineName', params: { machineName: 'experience' } });
  }

  return next();
}
